import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader, TruncatedCell } from '@/components';
import { formatISODate } from '@/utils/date';
import { VitalDataRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createVitalsColumns = (): ColumnDef<VitalDataRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Vital',
    cell: ({ row }) =>
      row.original.name ? (
        <TruncatedCell text={row.original.name} className="font-medium" />
      ) : (
        'No data available'
      ),
  },
  {
    accessorKey: 'value',
    header: 'Value',
    cell: ({ row }) => row.original.value || 'No data available',
  },
  {
    accessorKey: 'units',
    header: 'Units',
    cell: ({ row }) => row.original.units || 'No data available',
  },
  {
    accessorKey: 'dateOfStudy',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date of Study</SortableHeader>
    ),
    cell: ({ row }) =>
      row.original.dateOfStudy
        ? formatISODate(row.original.dateOfStudy)
        : 'No data available',
  },
  {
    id: 'sourceType',
    accessorFn: (row) => row.sourceTypes,
    header: 'Sources',
    cell: ({ row }) => {
      const sourceTypes = row.original.sourceTypes ?? [];
      if (sourceTypes.length === 0) {
        return 'No data available';
      }
      return sourceTypes.join(', ');
    },
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => {
      const firstSourceType = row.original.sourceTypes[0];
      return (
        <div className="flex items-center justify-end">
          <PatientDocumentViewButton
            disabled={!firstSourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_DATA,
              type: DocumentType.VITALS,
              vitalId: row.original.id,
              sourceType: firstSourceType,
              name: row.original.name,
            }}
          />
        </div>
      );
    },
  },
];
